export enum ItRequisitionTypeCodes {
  NEW_SIM_CARD = 1,
  EMAIL = 2,
  BUILD_SMART_ACCESS = 3,
  ACCESSORIES = 4,
  ASSET_TRANSFER = 5,
  ASSET_RETURN = 6,
  CARTRIDGE = 7,
  IT_ASSETS = 8,
  MAINTENANCE = 9,
  INTERNATIONAL_CALLS = 10,
  ASSET_STATUS_CHANGE = 11,
  CONSUMABLES = 13,
  LOST_SIM_CARD = 14,
  SIM_ADDON_REQUEST = 16,
}
